// Bilingual in-app user guide content (RO primary / EN fallback).
// Each section: { id, icon, title, blurb, topics: [{ q, a }] }
// `a` may be a string (paragraph) or an array of strings (rendered as bullets).
// Icons are lucide-react names resolved in Guide.jsx.

const ro = [
  {
    id: "overview",
    icon: "Compass",
    title: "Prezentare generală",
    blurb: "LactoPilot este platforma ERP pentru fabrica ta de lactate — de la recepția laptelui până la avize și trasabilitate.",
    topics: [
      {
        q: "Ce face aplicația?",
        a: [
          "Recepție lapte: înregistrează loturile de lapte primite de la furnizori.",
          "Producție: creează producții, urmărește randamentul pe ambalaje și subprodusele.",
          "Stoc & loturi: vezi ce ai pe stoc, expirările și starea de depozitare.",
          "Comenzi & avize: creează comenzi și generează avize cu PDF.",
          "Trasabilitate & HACCP: urmărește un lot în ambele sensuri și ține evidența punctelor critice.",
          "Forță de muncă: operatori, pontaj, sarcini și reclamații.",
        ],
      },
      {
        q: "Roluri de utilizatori",
        a: [
          "Administrator: acces complet, inclusiv setări, utilizatori, permisiuni și facturare.",
          "Manager: acces la producție, stoc, comenzi și rapoarte (configurabil).",
          "Operator: acces la operațiunile zilnice permise de administrator.",
          "Client: acces doar la portalul de client (comenzi proprii).",
        ],
      },
      {
        q: "Cum navighezi",
        a: "Meniul din stânga este grupat pe module (Recepție lapte, Producție, Stoc & Comenzi, Forță de muncă, Setări). Apasă pe un modul pentru a-l extinde. Fiecare pagină are filtre și căutare proprii. Poți schimba limba (RO/EN) din bara de sus.",
      },
      {
        q: "Flux tipic zilnic",
        a: [
          "1. Înregistrează recepția de lapte.",
          "2. Creează producțiile zilei (se consumă laptele).",
          "3. Loturile de stoc se creează automat din randamentul producției.",
          "4. Creează comenzile clienților.",
          "5. Generează avizele și PDF-urile de livrare.",
          "6. Verifică trasabilitatea și înregistrările HACCP.",
        ],
      },
    ],
  },
  {
    id: "milk",
    icon: "Milk",
    title: "Recepție lapte",
    blurb: "Înregistrează materia primă și pregătește-o pentru producție.",
    topics: [
      { q: "Lapte (recepție)", a: "Înregistrează fiecare lot de lapte primit: furnizor, cantitate, grăsime, temperatură și alți parametri. Fiecare lot primește un cod folosit apoi în trasabilitate." },
      { q: "Furnizori", a: "Gestionează lista de furnizori de lapte. Datele furnizorului apar pe recepții și în trasabilitate." },
      { q: "Calculator grăsime", a: "Calcul Pearson pentru standardizarea grăsimii laptelui — introdu valorile și obții amestecul necesar." },
    ],
  },
  {
    id: "production",
    icon: "FlaskConical",
    title: "Producție",
    blurb: "De la lapte la produs finit, cu randament pe ambalaje și subproduse.",
    topics: [
      { q: "Producții", a: "Creează o producție prin asistent (wizard): alege produsul, laptele consumat, controlul de calitate și randamentul. La finalizare, loturile de stoc se creează automat." },
      {
        q: "Randament pe ambalaje & Congelat/Refrigerat",
        a: [
          "Pentru fiecare linie de ambalaj (ex. 500g, 180g) introduci cantitatea produsă.",
          "La produsele de congelator poți alege, pe fiecare linie, starea: Congelat sau Refrigerat.",
          "Astfel, dintr-un singur lot poți trimite o parte la congelator și o parte la refrigerare.",
        ],
      },
      { q: "Subproduse", a: "Urmărește subprodusele (ex. zer). Loturile SUB- pot fi consumate în alte producții și apar în trasabilitate." },
      { q: "Materii prime în producție", a: "Adaugă materii prime (cheag, culturi, sare) consumate într-o producție. La selectare vezi și numărul lotului de la furnizor, ca să știi ce alegi. Poți adăuga sau modifica materiile prime și pe producțiile deja create (deschide producția → Editează)." },
      { q: "Planificare", a: "Planifică producțiile viitoare și vizualizează-le în tabelul de planificare din Dashboard." },
      { q: "Produse & sub-variante vandabile", a: "Definește tipurile de produse fabricate. Pentru fiecare produs poți adăuga sub-variante vandabile (ex. „Telemea proaspătă”) cu propriul termen de valabilitate mai scurt — se configurează în pagina Produse și se pot vinde ca orice produs." },
      { q: "Adaugă sub-variantă în stoc (din producție)", a: "În detaliul oricărei producții (inclusiv cele mai vechi), secțiunea „Adaugă sub-variantă în stoc” îți permite să aloci o parte din șarjă ca sub-variantă vandabilă. Aceasta intră în stoc cu valabilitatea proprie a variantei (calculată automat) și rămâne trasabilă către producția-părinte." },
      { q: "Șabloane (Ținte produs)", a: "Setează valabilitățile, maturarea, randamentul țintă și depozitarea în congelator. Vezi secțiunea „Setări explicate” de mai jos." },
    ],
  },
  {
    id: "stock",
    icon: "Package",
    title: "Stoc & Comenzi",
    blurb: "Gestionează loturile, vinde și livrează cu avize și PDF-uri.",
    topics: [
      { q: "Stoc & loturi", a: "Vezi loturile disponibile: cantitate, cantitate rămasă și expirare. Poți ascunde produsele epuizate; rândurile cu stoc 0 sunt evidențiate cu roșu." },
      { q: "Rebatch (reambalare)", a: "Împarte un lot existent într-un ambalaj mai mic — de exemplu, dintr-un lot mare de telemea creezi bucăți mai mici, păstrând trasabilitatea către lotul-părinte. Porția reambalată primește o expirare nouă = azi + valabilitatea la refrigerare, iar data de azi este reținută ca dată de ambalare." },
      {
        q: "Congelat vs Refrigerat & „Scoate din congelator”",
        a: [
          "La producție, loturile Congelate primesc expirarea din termenul normal de valabilitate, iar loturile Refrigerate primesc expirarea din valabilitatea la refrigerare (mai scurtă).",
          "Valabilitatea la refrigerare se aplică loturilor refrigerate, la scoaterea din congelator și la reambalarea în porții mai mici.",
          "Butonul „Scoate din congelator” trece un lot din congelat în refrigerat și recalculează expirarea = data intrării în stoc + valabilitatea la refrigerare.",
          "Funcția apare doar la produsele marcate ca „Congelator” în Ținte produs.",
        ],
      },
      { q: "Comenzi", a: "Creează comenzi pentru clienți. Poți filtra comenzile după client." },
      {
        q: "Avize de livrare",
        a: [
          "Generează avize și PDF-uri de livrare pentru clienți.",
          "Dacă un lot expiră prea curând (sub „Valabilitate min. vânzare”), aplicația blochează vânzarea și afișează o confirmare — poți alege „Vinde oricum”.",
        ],
      },
      { q: "Clienți, Liste de prețuri, Ambalaje produs", a: "Gestionează clienții, prețurile pe client/produs și ambalajele disponibile pentru fiecare produs." },
    ],
  },
  {
    id: "quality",
    icon: "ScanSearch",
    title: "Trasabilitate & HACCP",
    blurb: "Conformitate și urmărire completă a loturilor.",
    topics: [
      { q: "Trasabilitate", a: "Urmărește un lot în ambele sensuri: înapoi la laptele și producția din care provine, și înainte la avizele și clienții către care a fost livrat. Include și subprodusele (loturi SUB-)." },
      { q: "HACCP", a: "Definește punctele critice de control (CCP) și ține înregistrările necesare pentru conformitate." },
    ],
  },
  {
    id: "workforce",
    icon: "UserCog",
    title: "Forță de muncă",
    blurb: "Operatori, pontaj și sarcini.",
    topics: [
      { q: "Operatori", a: "Gestionează angajații care apar în producții și pontaj." },
      { q: "Pontaj (Time Clock)", a: "Înregistrează intrările/ieșirile angajaților. Poate fi folosit și în mod chioșc (kiosk)." },
      { q: "Sarcini & Reclamații", a: "Atribuie sarcini echipei și înregistrează reclamațiile clienților pentru urmărire." },
    ],
  },
  {
    id: "settings",
    icon: "Settings",
    title: "Setări explicate",
    blurb: "Ce face fiecare setare importantă.",
    topics: [
      { q: "Setări companie", a: "Numele firmei, logo-ul și datele fiscale. Acestea apar pe avizele și PDF-urile generate." },
      {
        q: "Ținte produs — câmpuri",
        a: [
          "Termen de valabilitate: zilele de la producție până la expirare pentru stocul normal (și cel congelat).",
          "Valabilitate la refrigerare: valabilitatea (mai scurtă) folosită ca expirare pentru loturile refrigerate — la producție (liniile refrigerate), la scoaterea din congelator și la reambalarea în porții mai mici.",
          "Valabilitate min. vânzare: numărul minim de zile rămase până la expirare ca să poți vinde un lot. Sub acest prag primești avertismentul „Vinde oricum”.",
          "Maturare: numărul de zile de maturare al produsului.",
          "Randament țintă: kilograme de produs obținute la 100 L de lapte.",
          "Congelator: dacă este activat, produsul se ține în congelator și devin disponibile stările Congelat/Refrigerat (în producție și în stoc).",
        ],
      },
      { q: "Permisiuni", a: "Configurează, pe fiecare rol, la ce secțiuni ale aplicației au acces utilizatorii. Doar administratorii pot modifica permisiunile." },
      { q: "Utilizatori", a: "Creează și administrează conturile de utilizator și rolurile lor." },
      { q: "Jurnal de activitate", a: "Istoricul acțiunilor efectuate în aplicație, util pentru audit." },
      { q: "Facturare", a: "Vezi planul SaaS curent și facturile asociate contului tău." },
    ],
  },
];

const en = [
  {
    id: "overview",
    icon: "Compass",
    title: "Overview",
    blurb: "LactoPilot is the ERP platform for your dairy — from milk reception to delivery notes and traceability.",
    topics: [
      {
        q: "What does the app do?",
        a: [
          "Milk reception: record milk batches received from suppliers.",
          "Production: create productions, track yield per packaging and byproducts.",
          "Stock & lots: see what you have in stock, expiries and storage state.",
          "Orders & delivery notes: create orders and generate delivery-note PDFs.",
          "Traceability & HACCP: trace a lot both ways and keep critical-control records.",
          "Workforce: operators, time clock, tasks and complaints.",
        ],
      },
      {
        q: "User roles",
        a: [
          "Admin: full access, including settings, users, permissions and billing.",
          "Manager: access to production, stock, orders and reports (configurable).",
          "Operator: access to the daily operations allowed by the admin.",
          "Client: access only to the client portal (their own orders).",
        ],
      },
      {
        q: "How to navigate",
        a: "The left menu is grouped into modules (Milk Reception, Production, Stock & Orders, Workforce, Settings). Click a module to expand it. Each page has its own filters and search. You can switch language (RO/EN) from the top bar.",
      },
      {
        q: "Typical daily flow",
        a: [
          "1. Record milk reception.",
          "2. Create the day's productions (milk is consumed).",
          "3. Stock lots are auto-created from production yield.",
          "4. Create client orders.",
          "5. Generate delivery notes and PDFs.",
          "6. Review traceability and HACCP records.",
        ],
      },
    ],
  },
  {
    id: "milk",
    icon: "Milk",
    title: "Milk Reception",
    blurb: "Record raw material and prepare it for production.",
    topics: [
      { q: "Milk (reception)", a: "Record each milk batch received: supplier, quantity, fat, temperature and other parameters. Each batch gets a code used later in traceability." },
      { q: "Suppliers", a: "Manage the list of milk suppliers. Supplier data appears on receptions and in traceability." },
      { q: "Fat calculator", a: "Pearson calculation for standardizing milk fat — enter the values to get the required blend." },
    ],
  },
  {
    id: "production",
    icon: "FlaskConical",
    title: "Production",
    blurb: "From milk to finished product, with yield per packaging and byproducts.",
    topics: [
      { q: "Productions", a: "Create a production via a wizard: choose the product, milk consumed, quality control and yield. On completion, stock lots are created automatically." },
      {
        q: "Yield per packaging & Frozen/Refrigerated",
        a: [
          "For each packaging line (e.g. 500g, 180g) you enter the produced quantity.",
          "For freezer products you can choose, per line, the state: Frozen or Refrigerated.",
          "This way a single batch can send part to the freezer and part to refrigeration.",
        ],
      },
      { q: "Byproducts", a: "Track byproducts (e.g. whey). SUB- lots can be consumed in other productions and appear in traceability." },
      { q: "Planning", a: "Plan future productions and view them in the planning table on the Dashboard." },
      { q: "Products", a: "Define the product types you manufacture." },
      { q: "Templates (Product targets)", a: "Set shelf lives, maturation, target yield and freezer storage. See the “Settings explained” section below." },
    ],
  },
  {
    id: "stock",
    icon: "Package",
    title: "Stock & Orders",
    blurb: "Manage lots, sell and deliver with notes and PDFs.",
    topics: [
      { q: "Stock & lots", a: "See available lots: quantity, remaining quantity and expiry. You can hide out-of-stock products; rows with 0 stock are highlighted in red." },
      { q: "Rebatch (repackage)", a: "Split an existing lot into a smaller package — e.g. create smaller pieces from a large cheese lot while keeping traceability to the parent lot. The repackaged portion gets a fresh expiry = today + refrigerated shelf life, and today is recorded as the packed-on date." },
      {
        q: "Frozen vs Refrigerated & “Take out of freezer”",
        a: [
          "At production, Frozen lots get their expiry from the normal shelf life, while Refrigerated lots get their expiry from the (shorter) refrigerated shelf life.",
          "The refrigerated shelf life applies to refrigerated lots, when taking a lot out of the freezer, and when repackaging into smaller portions.",
          "The “Take out of freezer” button moves a lot from frozen to refrigerated and recalculates expiry = stock date + refrigerated shelf life.",
          "This feature only appears for products marked as “Freezer” in Product targets.",
        ],
      },
      { q: "Orders", a: "Create orders for clients. You can filter orders by client." },
      {
        q: "Delivery notes",
        a: [
          "Generate delivery notes and PDFs for clients.",
          "If a lot expires too soon (below “Min sale shelf life”), the app blocks the sale and shows a confirmation — you can choose “Sell anyway”.",
        ],
      },
      { q: "Clients, Price lists, Product packaging", a: "Manage clients, per-client/product prices and the packaging options available for each product." },
    ],
  },
  {
    id: "quality",
    icon: "ScanSearch",
    title: "Traceability & HACCP",
    blurb: "Compliance and full lot tracking.",
    topics: [
      { q: "Traceability", a: "Trace a lot both ways: back to the milk and production it came from, and forward to the delivery notes and clients it was shipped to. Byproducts (SUB- lots) are included." },
      { q: "HACCP", a: "Define critical control points (CCP) and keep the records needed for compliance." },
    ],
  },
  {
    id: "workforce",
    icon: "UserCog",
    title: "Workforce",
    blurb: "Operators, time clock and tasks.",
    topics: [
      { q: "Operators", a: "Manage the employees who appear in productions and time clock." },
      { q: "Time clock", a: "Record employee clock-in/out. It can also be used in kiosk mode." },
      { q: "Tasks & Complaints", a: "Assign tasks to the team and log client complaints for follow-up." },
    ],
  },
  {
    id: "settings",
    icon: "Settings",
    title: "Settings explained",
    blurb: "What each important setting does.",
    topics: [
      { q: "Company settings", a: "Company name, logo and fiscal details. These appear on generated delivery notes and PDFs." },
      {
        q: "Product targets — fields",
        a: [
          "Shelf life: days from production to expiry for normal (and frozen) stock.",
          "Refrigerated shelf life: the shorter shelf life used as the expiry for refrigerated lots — at production (refrigerated lines), when taking a lot out of the freezer, and when repackaging into smaller portions.",
          "Min sale shelf life: the minimum days-to-expiry required to sell a lot. Below this threshold you get the “Sell anyway” warning.",
          "Maturation: the product's maturation days.",
          "Target yield: kilograms of product obtained per 100 L of milk.",
          "Freezer: when enabled, the product is kept in a freezer and the Frozen/Refrigerated states become available (in production and stock).",
        ],
      },
      { q: "Permissions", a: "Configure, per role, which sections of the app users can access. Only admins can change permissions." },
      { q: "Users", a: "Create and manage user accounts and their roles." },
      { q: "Activity log", a: "History of actions performed in the app, useful for auditing." },
      { q: "Billing", a: "View your current SaaS plan and the invoices associated with your account." },
    ],
  },
];

export const GUIDE_CONTENT = { ro, en };
